module.exports = "<p>\r\n  b3 works!\r\n</p>\r\n"